export default "__VITE_ASSET__CUNWgD3c__"